<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading full-character-formatting" id="uncategorized">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">For Jon and Marianna Knox, the birth of their daughter Persephone marks the happiest day of their lives. Until they learn that Persey is suffering from a rare but fatal condition called “triploidy.”</p>
<p class="subsq">Her doctors are baffled. And with good reason, because the source of the little girl’s genetic malfunction is not of this Earth. It lies out beyond the orbit of Saturn.</p>
<p class="subsq">And it’s coming for all of us.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookdescription.vue?58142e7e